// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"781ba38a","910":"360a6a24"}[chunkId] + ".chunk.js";
};